import React, { useState } from 'react';
import { ButtonBlue } from '../../../HouseStyle/Components/Buttons';
import ProductRelationsModal from '../../modals/ProductRelationsModal';

const RelatedProductsBox = ({ productId }) => {
  const [showUpsellModal, setShowUpsellModal] = useState(false);
  const [showCrossSellModal, setShowCrossSellModal] = useState(false);

  return (
    <>
      <div className="whiteBox p-5 h-100">
        <h5 className="inputTitle mb-4">Gerelateerde producten</h5>
        
        <div className="d-flex flex-column gap-3">
          <div className="d-flex flex-column gap-2">
            <p className="mb-2 fw-semibold">Upsell</p>
            <p className="text-muted small mb-2">Duurder alternatief product</p>
            <ButtonBlue
              text="Beheer upsell producten"
              onClickFunction={() => setShowUpsellModal(true)}
            />
          </div>

          <div className="d-flex flex-column gap-2">
            <p className="mb-2 fw-semibold">Cross-sell</p>
            <p className="text-muted small mb-2">Aanvullend product (vaak samen gekocht)</p>
            <ButtonBlue
              text="Beheer cross-sell producten"
              onClickFunction={() => setShowCrossSellModal(true)}
            />
          </div>
        </div>
      </div>

      {/* Modals */}
      {showUpsellModal && (
        <ProductRelationsModal
          show={showUpsellModal}
          setShow={setShowUpsellModal}
          productId={productId}
          relationType="upsell"
        />
      )}

      {showCrossSellModal && (
        <ProductRelationsModal
          show={showCrossSellModal}
          setShow={setShowCrossSellModal}
          productId={productId}
          relationType="cross-sell"
        />
      )}
    </>
  );
};

export default RelatedProductsBox;
